import { Button } from "@mui/material";
import React from "react";

type BasicButtonProps = {
  children: React.ReactNode;
  mt?: number;
  onClick: () => void;
  color?: "primary" | "secondary";
};

const BasicButton: React.FC<BasicButtonProps> = ({
  children,
  mt = 0,
  onClick,
  color = "primary",
}) => {
  return (
    <Button
      variant="contained"
      color={color}
      fullWidth
      onClick={onClick}
      sx={{ mt }}
    >
      {children}
    </Button>
  );
};

export default BasicButton;
